import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import DatePickerComponent from '../../DatePicker';

const Root = styled.div`
  > div {
    flex-grow: 1;
  }

  @media (max-width: 640px) {
    .wrapper-container {
      flex-wrap: wrap;
      gap: 1rem;

      .register {
        flex-grow: 1;
        .inputsWrapper {
          width: 100%;
        }
      }

      .datePickerWrapper {
        margin-left: 0;
      }
    }
  }

  .register {
    display: flex;
    align-items: center;
    background-color: var(--tonal);
    border-radius: 0.25rem;
    height: 2.5rem;
    .labelName {
      white-space: nowrap;
      padding: 0 0.75rem;
      font-size: 0.875rem;
      color: var(--text-secondary);
      border-right: 1px solid var(--outline);
      height: inherit;
      display: flex;
      align-items: center;
    }
    .inputsWrapper {
      display: flex;
      align-items: center;
    }
  }
  .datePickerWrapper {
    margin-left: 0.5rem;
    background-color: var(--tonal);
    border-radius: 0.25rem;
    .labelName {
      width: fit-content;
      padding: 0 0.75rem;
      font-size: 0.875rem;
      color: var(--text-secondary);
      border-right: 1px solid var(--outline);
    }
    .inputMask {
      width: inherit;
      text-align: center;
    }
  }
`;

interface Props {
  workerInputSet: any;
  cdName: string;
  isViewMode: boolean;
  setWorkerInputSet: any;
  isNewAdd: boolean;
}

const SafeEdu = ({ workerInputSet, cdName, isViewMode, setWorkerInputSet, isNewAdd }: Props) => {
  const { t } = useTranslation();
  const { safeeduReg, safeeduDate } = workerInputSet;
  const [inputs, setInputs] = useState<string>(safeeduReg);
  const [date, setDate] = useState(safeeduDate);

  useEffect(() => {
    if (date !== safeeduDate) setWorkerInputSet({ ...workerInputSet, safeeduDate: date });
  }, [date]);

  useEffect(() => {
    if (inputs !== safeeduReg || date !== safeeduDate) {
      setInputs(safeeduReg);
      setDate(safeeduDate);
    }
  }, [safeeduReg, safeeduDate]);

  const onBlurReg = () => {
    if (inputs !== safeeduReg) {
      setWorkerInputSet({ ...workerInputSet, safeeduReg: inputs });
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    // 영문자, 한글(완성형+자음+모음), 숫자, 하이픈(-), 슬래시(/)만 허용하는 정규식
    const allowedPattern = /^[a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9/-]*$/;

    if (allowedPattern.test(value)) {
      setInputs(value);
    }
  };

  return (
    <Root className='control inputs safeedu'>
      <label htmlFor={cdName}>{cdName}</label>
      <div className='flex-basic wrapper-container'>
        <div className='register'>
          <span className='labelName'>{t('등록 번호')}</span>
          <div className='inputsWrapper'>
            <input className='text-center' type='text' name='reg' value={inputs} maxLength={23} onChange={onChange} onBlur={onBlurReg} placeholder='0000-000-00000' />
          </div>
        </div>
        <div className='datePickerWrapper'>
          <label className='labelName'>{t('이수 일자')}</label>
          <DatePickerComponent
            startDate={date} //
            setDate={setDate}
            popperPlacement='bottom'
            disabled={isViewMode}
          />
        </div>
      </div>
    </Root>
  );
};

export default SafeEdu;
